module.exports = __webpack_public_path__ + "img/scene-public.737b7b59.jpg";